import React from 'react';
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { GrMail } from "react-icons/gr";
import { SiLeetcode } from "react-icons/si";

const Contact = () => {
  const contacts = [
    {
      label: 'Email',
      value: 'devireddyvishnu12@gmail.com',
      href: 'mailto:devireddyvishnu12@gmail.com',
      icon: <GrMail/>
    },
    {
      label: 'LinkedIn',
      value: 'vishnuvardhana-reddy-devi-reddy',
      href: 'https://www.linkedin.com/in/vishnuvardhana-reddy-devi-reddy/',
      icon: <FaLinkedin/>
    },
    {
      label: 'GitHub',
      value: 'VishnuDevi123',
      href: 'https://github.com/VishnuDevi123',
      icon: <FaGithub/>
    },
    {
      label: 'LeetCode',
      value: 'RmXm8s4BfI',
      href: 'https://leetcode.com/u/RmXm8s4BfI/',
      icon: <SiLeetcode/>
    },
  ];

  return (
    <div className="ContactPage">
      <h1 className="contactHeading">Let&apos;s connect</h1>
      <p className="contactTagline">
        Open to full-stack, AI/ML, and platform roles. Feel free to reach out!.
      </p>

      <div className="contactGrid">
        {contacts.map((item) => (
          <a key={item.label} className="contactCard" href={item.href} target="_blank" rel="noreferrer">
            <div className="contactIcon">{item.icon}</div>
            <div>
              <h3>{item.label}</h3>
              <p>{item.value}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  )
}

export default Contact;
